<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Add To Waitlist</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="alert alert-danger text-center mb-3" role="alert"
         *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <p>
      <b *ngIf="scheduledEvent">{{ scheduledEvent.name }}</b>
      <b *ngIf="!scheduledEvent">{{ eventType.name }}</b>
    </p>

    <div class="form-group" *ngIf="scheduledEvent">
      <hr>

      <div class="form-check">
        <input class="form-check-input" type="radio"
               name="addViaClimberApp" id="addViaClimberAppTrue"
               [(ngModel)]="addViaClimberApp"
               [value]="true">
        <label class="form-check-label" for="addViaClimberAppTrue">
          Add participant via Climber App to collect participant details
        </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio"
               name="addViaClimberApp" id="addViaClimberAppFalse"
               [(ngModel)]="addViaClimberApp"
               [value]="false">
        <label class="form-check-label" for="addViaClimberAppFalse">
          Add participant directly onto waitlist without collecting additional participant details
        </label>
      </div>
    </div>

    <ng-container *ngIf="addViaClimberApp !== null">
      <hr>

      <div class="form-group">
        <label for="searchCustomersInput">
          <ng-container *ngIf="addViaClimberApp === true">
            Primary Customer for Booking (Optional)
          </ng-container>
          <ng-container *ngIf="addViaClimberApp === false">
            Participant
          </ng-container>
        </label>
        <input type="text" class="form-control" id="searchCustomersInput"
               placeholder="Search by email, name, barcode, or telephone"
               [(ngModel)]="search"
               (ngModelChange)="handleCustomerFilterChange()">
      </div>

      <!-- Add a fixed-height div to prevent the input from shifting as results are loaded -->
      <div class="mt-3 mb-3" style="height: 231px;overflow-y: auto"
           *ngIf="(selectedCustomer === null) && hasSearchInput()">

        <ng-container *ngIf="hasSearchInput()">

          <table class="table table-bordered table-hover">
            <tbody *ngIf="!customerResultsPresent()">
              <tr>
                <td colspan="99">
                  {{ loadingCustomers ? 'Loading...' : 'No results' }}
                </td>
              </tr>
            </tbody>
            <tbody *ngIf="customerResultsPresent()">
              <tr style="cursor:pointer"
                  *ngFor="let customer of customerList.results"
                  (click)="selectCustomer(customer)">
                <td>
                  {{ customer.first_name }} {{ customer.last_name }}
                  <span class="text-muted">
                    {{ dateStringFromISO8601(customer.birthday )}}
                    <span *ngIf="customer.email">- {{ customer.email }}</span>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="alert alert-info" *ngIf="!loadingCustomers && hasRecentActivityFilter()">
            Only recently-active customers are being shown.
            <a href="#" (click)="$event.preventDefault(); handleExpandSearch();">
              Expand search to all customers.
            </a>
          </div>

        </ng-container>

      </div>

      <app-age-restriction-bypass-warning [violations]="ageRestriction.violations"
                                          [atEventStart]="!!scheduledEvent"
                                          [(acknowledged)]="ageRestriction.acknowledged"
                                          [disabled]="loadingSubmit"></app-age-restriction-bypass-warning>

      <div class="form-group" *ngIf="addViaClimberApp === false">
        <label for="notificationEmailInput">
          Notification Email
        </label>
        <input type="email" class="form-control" id="notificationEmailInput"
               autocomplete="off"
               [(ngModel)]="notificationEmail">
      </div>

      <small class="form-text text-muted"
             *ngIf="scheduledEvent && (addViaClimberApp === false)">
        This will bypass any participant questions that pertain to this event's waitlist.
      </small>

      <div class="form-group"
           *ngIf="eventType && eventType.allow_waitlist_customers_to_select_preferred_days_of_week">
        <label>Preferred Days of Week</label>

        <div class="form-check">
          <input class="form-check-input" type="checkbox"
                 id="prefersMonday" name="prefersMonday"
                 [(ngModel)]="prefersMonday">
          <label class="form-check-label" for="prefersMonday">Monday</label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox"
                 id="prefersTuesday" name="prefersTuesday"
                 [(ngModel)]="prefersTuesday">
          <label class="form-check-label" for="prefersTuesday">Tuesday</label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox"
                 id="prefersWednesday" name="prefersWednesday"
                 [(ngModel)]="prefersWednesday">
          <label class="form-check-label" for="prefersWednesday">Wednesday</label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox"
                 id="prefersThursday" name="prefersThursday"
                 [(ngModel)]="prefersThursday">
          <label class="form-check-label" for="prefersThursday">Thursday</label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox"
                 id="prefersFriday" name="prefersFriday"
                 [(ngModel)]="prefersFriday">
          <label class="form-check-label" for="prefersFriday">Friday</label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox"
                 id="prefersSaturday" name="prefersSaturday"
                 [(ngModel)]="prefersSaturday">
          <label class="form-check-label" for="prefersSaturday">Saturday</label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox"
                 id="prefersSunday" name="prefersSunday"
                 [(ngModel)]="prefersSunday">
          <label class="form-check-label" for="prefersSunday">Sunday</label>
        </div>
      </div>

      <div class="form-group"
           *ngIf="eventType && eventType.allow_waitlist_customers_to_select_preferred_locations">
        <label>Preferred Locations</label>

        <ng-container *ngIf="locations !== null">
          <div class="form-check" *ngFor="let location of locations">
            <input class="form-check-input" type="checkbox"
                   id="prefersLoc{{ location.id }}" name="prefersLoc{{ location.id }}"
                   [(ngModel)]="prefersLocation[location.id]">
            <label class="form-check-label" for="prefersLoc{{ location.id }}">
              {{ location.name }}
            </label>
          </div>
        </ng-container>
      </div>
    </ng-container>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <a class="btn btn-primary"
       *ngIf="(addViaClimberApp === true) && !loadingSubmit"
       href="#"
       (click)="$event.preventDefault();handleGoToScheduler();">
      Go to Scheduler
    </a>
    <button class="btn btn-primary" type="button"
            *ngIf="(addViaClimberApp === false) && !loadingSubmit"
            [disabled]="!addToWaitlistAllowed()"
            [class.disabled]="!addToWaitlistAllowed()"
            (click)="handleAddToWaitlist()">
      Add To Waitlist
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
  </div>

</ng-container>
